export default "__VITE_ASSET__mOuPSR8G__"